import { captureEvent } from '@/services/analytics';
import { AxiosError, http } from '@/services/http';
import { storage, StorageKeys } from '@/services/storage';
import { getInternalBasePath } from '@/shared/lib/environmentPaths';
import type { UserMetadata, UserSubscription } from '@/shared/types/auth';

export type LoginTripResponse = {
  token: string;
  userEmail: string;
  access: string;
  hsObjectId: string;
  metadata: UserMetadata[];
  subscription: UserSubscription;
};

export const loginApi = {
  fetchTripToken: async (gxToken: string): Promise<LoginTripResponse> => {
    try {
      const { data } = await http.internal.get(`${getInternalBasePath()}token`, {
        params: { token: gxToken }
      });
      storage.set(StorageKeys.TripToken, data.token);
      return data as LoginTripResponse;
    } catch (error) {
      if (error instanceof AxiosError && error.response) {
        throw new Error(
          JSON.stringify({ data: error.response.data, status: error.response.status }),
          { cause: error }
        );
      }
      captureEvent('user_token_error', { error });
      throw error;
    }
  }
};
